/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePhaseDto } from '../../models/create-phase-dto';
import { PhaseWithContent } from '../../models/phase-with-content';

export interface IlsControllerAddPhaseToIls$Params {
  ilsId: string;
      body: CreatePhaseDto
}

export function ilsControllerAddPhaseToIls(http: HttpClient, rootUrl: string, params: IlsControllerAddPhaseToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<PhaseWithContent>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerAddPhaseToIls.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PhaseWithContent>;
    })
  );
}

ilsControllerAddPhaseToIls.PATH = '/ils/{ilsId}/phase';
